const hasRequiredVariableValue = value => {
  if (value == null) return false
  if (typeof value === "string") return value.trim().length > 0
  return true
}

const isRequiredVariableForTemplate = ({ catalogEntry, isManagedPassTemplate = false }) => {
  if (!catalogEntry) return false

  if (catalogEntry.required_managed !== undefined || catalogEntry.required_standard !== undefined) {
    return Number(isManagedPassTemplate ? catalogEntry.required_managed : catalogEntry.required_standard) === 1
  }

  // Backward compatibility for older payloads
  if (catalogEntry.required !== undefined) return Number(catalogEntry.required) === 1

  return false
}

const isRequiredVariableValueForTemplate = ({ catalogEntry, isManagedPassTemplate = false }) => {
  if (!catalogEntry) return false

  if (catalogEntry.required_value !== undefined && catalogEntry.required_value !== null) {
    return Number(catalogEntry.required_value) === 1
  }

  return false
}

const isRequiredVariableValue = isRequiredVariableValueForTemplate

const validateRequiredVariableValue = ({ value, catalogEntry, label = "A value", isManagedPassTemplate = false }) => {
  if (!isRequiredVariableValueForTemplate({ catalogEntry, isManagedPassTemplate })) return { valid: true, helperText: "" }

  return hasRequiredVariableValue(value)
    ? { valid: true, helperText: "" }
    : { valid: false, helperText: `${label} is required.` }
}

export { hasRequiredVariableValue, isRequiredVariableForTemplate, isRequiredVariableValue, isRequiredVariableValueForTemplate, validateRequiredVariableValue }
